import React, {FC} from 'react';
import moment from 'moment';
import {
  getTransportDateLabel,
  getTransportReferenceLabel,
  getTransportTimeLabel,
  getTransportDetailsLabel
} from '../../transfers/utils/transportLabels';
import {TransferDirectionEnum} from '../../transfers/enums/TransferDirectionEnum';
import Transfer from "../../transfers/types/Transfer";
import useTranslate from "../../core/languages/hooks/useTranslate";
import TitleCardSection from "./TitleCardSection";

interface TransportDetailsSectionProps {
  transferInfo: Transfer;
}

const TransportDetailsSection: FC<TransportDetailsSectionProps> = ({transferInfo}) => {
  const t = useTranslate();

  return (
    <div className="mb-10">
      <TitleCardSection
          title={getTransportDetailsLabel(t, transferInfo.transport)}
          subtitle={t("transferOk.message.transportDetailsSubtitle")}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div
          className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <i className="las la-building text-purple-600 dark:text-purple-400 text-2xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">
                {getTransportReferenceLabel(t, transferInfo?.transport, 'reference')}
              </p>
              <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 mt-1">
                {transferInfo?.transportReference || '-'}
              </p>
            </div>
          </div>
        </div>

        <div
          className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <i className="las la-ticket-alt text-violet-600 dark:text-violet-400 text-2xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">
                {getTransportReferenceLabel(t, transferInfo?.transport, "number")}
              </p>
              <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 mt-1">
                {transferInfo?.transportReferenceNumber || '-'}
              </p>
            </div>
          </div>
        </div>

        <div
          className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <i className="las la-calendar text-purple-700 dark:text-purple-400 text-2xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">
                {getTransportDateLabel(t, transferInfo?.transport, transferInfo?.direction === TransferDirectionEnum.ARRIVAL ? 'arrival' : 'departure')}
              </p>
              <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 mt-1">
                {transferInfo?.transportDate ? moment(transferInfo.transportDate).format('DD/MM/YYYY') : '-'}
              </p>
            </div>
          </div>
        </div>

        <div
          className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <i className="las la-clock text-purple-700 dark:text-purple-400 text-2xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">
                {getTransportTimeLabel(t, transferInfo?.transport, transferInfo?.direction === TransferDirectionEnum.ARRIVAL ? 'arrival' : 'departure')}
              </p>
              <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 mt-1">
                {transferInfo?.transportTime ? (typeof transferInfo.transportTime === 'string' ? transferInfo.transportTime : moment(transferInfo.transportTime).format('HH:mm')) : '-'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransportDetailsSection;

